import React from 'react';
import { Typography, Box, Stack, Paper, Grid } from '@mui/material';
import profile from '../profileData';

const Papers = () => (
  <Box id="papers" sx={{ py: { xs: 3, md: 5 }, px: { xs: 1, md: 0 }, maxWidth: { xs: '100%', md: 1200 }, mx: 'auto' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      <Box sx={{ width: 4, height: 32, bgcolor: 'primary.main', mr: 2, borderRadius: 2 }} />
      <Typography variant="h4" fontWeight={700} sx={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: 1, fontSize: { xs: 24, md: 32 } }}>
        Publications
      </Typography>
    </Box>

    {/* Peer-reviewed Publications Section */}
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" fontWeight={600} sx={{ fontFamily: 'Montserrat, sans-serif', mb: 3 }}>
        Peer-reviewed Publications
      </Typography>
      <Stack spacing={3}>
        {profile.publications.map((paper, idx) => (
          <Paper 
            key={idx} 
            elevation={1}
            sx={{ 
              p: 2.5, 
              borderRadius: 2,
              '&:hover': {
                boxShadow: 2,
                transform: 'translateY(-2px)',
                transition: 'all 0.2s ease-in-out'
              }
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" fontWeight={600} sx={{ fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 16, md: 18 } }}>
                  {paper.title}
                </Typography>
                <Typography variant="subtitle1" sx={{ color: 'text.secondary', fontSize: { xs: 14, md: 16 }, mb: 1 }}>
                  {paper.authors}
                </Typography>
                <Typography variant="subtitle1" sx={{ color: 'text.secondary', fontSize: { xs: 14, md: 16 }, mb: 1 }}>
                  {paper.venue}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  {paper.links.map((link, idx) => (
                    <Typography
                      key={idx}
                      component="a"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: 'primary.main',
                        textDecoration: 'none',
                        fontSize: { xs: 14, md: 16 },
                        border: '1px solid',
                        borderColor: 'primary.main',
                        borderRadius: 1,
                        px: 1.5,
                        py: 0.5,
                        '&:hover': {
                          bgcolor: 'primary.main',
                          color: 'white'
                        }
                      }}
                    >
                      {link.label}
                    </Typography>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Paper>
        ))}
      </Stack>
    </Box>

    {/* Work in Progress Section */}
    <Box sx={{ mt: 6 }}>
      <Typography variant="h5" fontWeight={600} sx={{ fontFamily: 'Montserrat, sans-serif', mb: 3 }}>
        Work in Progress
      </Typography>
      <Stack spacing={3}>
        {profile.research.map((paper, idx) => (
          <Paper 
            key={idx} 
            elevation={1}
            sx={{ 
              p: 2.5, 
              borderRadius: 2,
              '&:hover': {
                boxShadow: 2,
                transform: 'translateY(-2px)',
                transition: 'all 0.2s ease-in-out'
              }
            }}
          >
            <Typography variant="h6" fontWeight={600} sx={{ fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 16, md: 18 } }}>
              {paper.title}
            </Typography>
            <Typography variant="subtitle1" sx={{ color: 'text.secondary', fontSize: { xs: 14, md: 16 } }}>
              {paper.authors}
            </Typography>
          </Paper>
        ))}
      </Stack>
    </Box>
  </Box>
);

export default Papers; 